module.exports = __webpack_public_path__ + "static/media/14.6ecf3db2.jpg";